import I18n from "i18n-js";
import { TitleLayout } from "features/creator/tutorial/top/stages/Layout";

const TOTAL_STEP = 12;

export const Title = ({ activeStep }: { activeStep: number }) => (
  <TitleLayout steps={TOTAL_STEP} activeStep={activeStep}>
    <div className="flex-col-el flex-center gap-2">
      <div className="flex-col-el flex-center bg-orange-100 rounded-full border-solid border-[4px] border-orange-100 px-1 w-[24px] h-[24px]">
        <p className="text-body text-[18px] text-white leading-[26px]">2</p>
      </div>
      <div className="flex-col-center">
        <div className="flex-row-el flex-center px-2 bg-orange-100 rounded-lg">
          <p className="text-body text-[14px] leading-6 text-white">
            {I18n.t("MSG_CREATOR_APP_MY_APPS")}
          </p>
        </div>
        <p className="text-body text-[18px] leading-6 text-orange-100">
          について
        </p>
      </div>
    </div>
  </TitleLayout>
);
